import _ from "lodash";
import moment from "moment";

import api from "@/api/cloud";
import { Storage } from "@/utils/storage";
import { get, set } from "../../utils/vuex";

// const storage = Storage.local();
const cache = Storage.local({
	cacheFor: moment.duration(1, "day").asMilliseconds(),
});

const initState = () => ({
	roles: cache.get("roles", {}),
	permissions: cache.get("permissions", {}),
});

export default {
	namespaced: true,
	state: initState(),

	getters: {
		roles: get("roles"),
		permission: get("permissions"),
	},

	mutations: {
		setRoles: set("roles"),

		setRolePermissions: (state, { roleId, permissions }) => {
			state.permissions = {
				...state.permissions,
				[roleId]: permissions || [],
			};
		},
	},

	actions: {
		async initRoles({ commit }) {
			// Get all user roles
			let roles = cache.get("roles");
			if (_.isNil(roles)) {
				const _roles = await api.getRoles();
				roles = _.keyBy(_roles, "_id");
				cache.set("roles", roles);

				_.each(_roles, (role)=>{
					commit("setRolePermissions", {
						roleId: role._id,
						permissions: role._permissions,
					});
				})
			}
			commit("setRoles", roles);
		},
	},
};
